// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"6df28b29","787":"c4bb32ee"}[chunkId] + ".chunk.js";
};